var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OrderedMap } from "immutable";
import * as React from "react";
/**
 *
 */
var misuse = new Error("misuse error: no ModalProvider in ancestors");
/**
 *
 */
export var modalWrapperBindingInit = function () { return ({
    showModal: function () {
        throw misuse;
    },
    closeModal: function () {
        throw misuse;
    },
}); };
/**
 *
 */
var ModalWrapperContext = React.createContext(modalWrapperBindingInit());
/**
 *
 */
var ModalWrapperProvider = /** @class */ (function (_super) {
    __extends(ModalWrapperProvider, _super);
    /**
     *
     * @param props
     */
    function ModalWrapperProvider(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            modals: OrderedMap(),
        };
        _this.showModal = _this.showModal.bind(_this);
        _this.closeModal = _this.closeModal.bind(_this);
        return _this;
    }
    /**
     *
     */
    ModalWrapperProvider.prototype.render = function () {
        var show = this.showModal;
        var close = this.closeModal;
        return (React.createElement(ModalWrapperContext.Provider, { value: {
                showModal: show,
                closeModal: close,
            } },
            React.createElement(React.Fragment, null, this.props.children),
            React.createElement(React.Fragment, null, this.state.modals
                .mapEntries(function (_a) {
                var _b = __read(_a, 2), k = _b[0], Clazz = _b[1];
                return [k, React.createElement(Clazz, { key: k })];
            })
                .toList()
                .toArray())));
    };
    /**
     *
     * @param handle
     * @param me
     */
    ModalWrapperProvider.prototype.showModal = function (handle, me) {
        // TODO
        var modals = this.state.modals;
        this.setState({
            modals: modals.set(handle, me),
        });
        return handle;
    };
    /**
     *
     * @param handle
     */
    ModalWrapperProvider.prototype.closeModal = function (handle) {
        var modals = this.state.modals;
        this.setState({
            modals: modals.delete(handle),
        });
    };
    return ModalWrapperProvider;
}(React.Component));
export { ModalWrapperProvider };
/**
 *
 */
export var ModalWrapperConsumer = ModalWrapperContext.Consumer;
